/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// // react-router-dom components
// import { Link } from "react-router-dom";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";

// Authentication layout components
import { Amplify, Auth } from "aws-amplify";

// Images
import sijillogo from "assets/images/logos/images.png"
import iam from "assets/images/logo-ct.png"
import "./index.css"
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import { Icon } from "@mui/material";
import { useSnackbar } from "notistack";

function SignIn() {
  const [rememberMe, setRememberMe] = useState(false);

  const [signUpType, setSignUpType] = useState("Individual");
  const [pagestate, setpagestate] = useState("signin")
  const [formstate, setformstate] = useState("")
  const [fullname, setfullname] = useState("");
  const [username, setusername] = useState("");
  const [email, setemail] = useState("")
  const [pass, setpass] = useState("");
  const [phonenum, setphonenum] = useState("")
  const [confirmpass, setconfirmpass] = useState("")
  const [code, setcode] = useState("")
  const [indterms, setindterms] = useState(false)
  const [orgterms, setorgterms] = useState(false)
  const [companyname, setcompanyname] = useState("")
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [inputValue, setInputValue] = useState('');
  const [cap, setcap] = useState();
  const [capstatus, setcapstatus] = useState(false)
  const [ssm, setssm] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    if (pagestate == "signup" && formstate == "org" || pagestate == "signup" && formstate == "ind") {
      try {
        loadCaptchaEnginge(6); // Load captcha with 6 characters
      } catch (error) {
        console.error("Error loading captcha engine:", error);
      }
    }
  }, [formstate]);

  if (pagestate == "signin") {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "90vh" }} >
        <div style={{ height: "100%", width: "center", display: 'flex', flexDirection: "row", alignItems: "center", justifyItems: "center" }}>

          <div style={{
            width: "50%",
            display: "flex",
            justifyContent: "center",  // Centers horizontally
            alignItems: "center",  // Centers vertically

          }}>
            <img src={iam} style={{ width: "50%" }} alt="Sijil Logo" />
          </div>

          <div style={{ width: "40%", display: 'flex', flexDirection: "row", alignItems: "center" }}>

            <div style={{ width: "90%" }}>
              <SuiBox mb={1}>
                <h3>Welcome to SIJIL</h3>
              </SuiBox>
              <SuiBox component="form" role="form">
                <SuiBox mb={1}>
                  <SuiBox mb={1} ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Username (IC/Passport No. without '-' )
                    </SuiTypography>
                  </SuiBox>
                  <SuiInput type="text" placeholder="Username (IC/Passport No. without '-' )" onChange={(e) => setusername(e.target.value)} />
                </SuiBox>
                <SuiBox mb={1}>
                  <SuiBox mb={1} ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Password
                    </SuiTypography>
                  </SuiBox>
                  <SuiInput type="password" placeholder="Password" onChange={(e) => setpass(e.target.value)} />
                </SuiBox>

                <SuiBox mt={3} mb={1}>
                  <SuiButton variant="contained" color="warning" fullWidth onClick={() => {
                    Auth.signIn(username, pass).then((val) => {
                      window.location.href = '/dashboard'
                    }).catch((error) => {
                      enqueueSnackbar(error.message, { variant: 'error' });
                      
                    })
                  }}>
                    sign in
                  </SuiButton>
                </SuiBox>
                <SuiBox mt={3} textAlign="center" style={{ display: "flex", justifyContent: "space-between" }}>
                  <SuiTypography
                    variant="button"
                    color="blue"
                    fontWeight="medium"
                    onClick={() => { setpagestate("forgotpass") }}
                    sx={{ cursor: "pointer" }}
                  >
                    Forgot Password{" "}
                  </SuiTypography>
                  <SuiTypography variant="button" color="text" fontWeight="regular">
                    Don&apos;t have an account?{" "}
                    <SuiTypography
                      variant="button"
                      color="blue"
                      fontWeight="medium"
                      onClick={() => { setpagestate("signup") }}
                      sx={{ cursor: "pointer" }}
                    >
                      Sign Up
                    </SuiTypography>
                  </SuiTypography>
                </SuiBox>
              </SuiBox>
            </div>

          </div>



        </div>

        <div style={{ position: "absolute", bottom: "0", width: "100%", textAlign: "center" }}>
          <SuiBox pb={0.3}>
            <SuiTypography variant="caption" color="secondary">
              Private & Confidential. © Digital Internet Association Malaysia. All Rights Reserved. {new Date().getFullYear()}
            </SuiTypography>
          </SuiBox>
        </div>


      </div>




    );
  } else if (pagestate == "forgotpass") {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "90vh" }}>

        <div style={{ height: "100%", width: "center", display: 'flex', flexDirection: "row", alignItems: "center", justifyItems: "center" }}>

          <div style={{
            width: "50%",
            display: "flex",
            justifyContent: "center",  // Centers horizontally
            alignItems: "center",  // Centers vertically

          }}>
            <img src={iam} style={{ width: "50%" }} alt="Sijil Logo" />
          </div>

          {confirmpass == "" ? (
            <div style={{ width: "40%", display: 'flex', flexDirection: "row", alignItems: "center" }}>

              <div style={{ width: "90%" }}>
                <SuiBox mb={1}>
                  <h3>Forgot Password</h3>
                </SuiBox>
                <SuiBox component="form" role="form">

                  <SuiBox mb={1}>
                    <SuiBox mb={1} ml={0.5}>
                      <SuiTypography component="label" variant="caption" fontWeight="bold">
                        Username (IC/Passport No. without '-' )
                      </SuiTypography>
                    </SuiBox>
                    <SuiInput type="text" placeholder="Username (IC/Passport No. without '-' )" onChange={(e) => setusername(e.target.value)} />
                  </SuiBox>

                  <SuiBox mt={3} mb={1}>
                    <SuiButton variant="contained" color="warning" fullWidth onClick={() => {
                      Auth.forgotPassword(username).then((val) => {
                        setpass("")
                        setusername("")
                        setphonenum("")
                        setemail("")
                        setfullname("")
                        //alert("Email have been sent.")
                        enqueueSnackbar("Email have been sent", { variant: 'success' });
                        setconfirmpass("yes")
                      }).catch((error) => {
                        enqueueSnackbar(error.message, { variant: 'error' });
                        //alert(error.message)
                      })
                    }}>
                      Reset
                    </SuiButton>
                  </SuiBox>
                  <SuiBox mt={3} textAlign="center">

                    <SuiTypography variant="button" color="text" fontWeight="regular">
                      Have an account?{" "}

                      <SuiTypography
                        variant="button"
                        color="info"
                        fontWeight="medium"
                        onClick={() => { setpagestate("signin") }}
                      >
                        Sign In
                      </SuiTypography>
                    </SuiTypography>
                  </SuiBox>
                </SuiBox>


              </div>



            </div>
          ) : (
            <div style={{ width: "40%", display: 'flex', flexDirection: "row", alignItems: "center" }}>

              <div style={{ width: "90%" }}>
                <SuiBox mb={1}>
                  <h3>Confirm Password</h3>
                </SuiBox>
                <SuiBox component="form" role="form">

                  <SuiBox mb={1}>
                    <SuiBox mb={1} ml={0.5}>
                      <SuiTypography component="label" variant="caption" fontWeight="bold">
                        Username (IC/Passport No. without '-' )
                      </SuiTypography>
                    </SuiBox>
                    <SuiInput type="text" placeholder="Username (IC/Passport No. without '-' )" onChange={(e) => setusername(e.target.value)} />
                  </SuiBox>

                  <SuiBox mb={1}>
                    <SuiBox mb={1} ml={0.5}>
                      <SuiTypography component="label" variant="caption" fontWeight="bold">
                        Code
                      </SuiTypography>
                    </SuiBox>
                    <SuiInput type="text" placeholder="Code" onChange={(e) => setcode(e.target.value)} />
                  </SuiBox>

                  <SuiBox mb={1}>
                    <SuiBox mb={1} ml={0.5}>
                      <SuiTypography component="label" variant="caption" fontWeight="bold">
                        New Password
                      </SuiTypography>
                    </SuiBox>
                    <SuiInput type="password" placeholder="New Password" onChange={(e) => setpass(e.target.value)} />
                  </SuiBox>

                  <SuiBox mt={3} mb={1}>
                    <SuiButton variant="contained" color="warning" fullWidth onClick={() => {
                      Auth.forgotPasswordSubmit(username, code, pass).then((val) => {
                        setpass("")
                        setusername("")
                        setphonenum("")
                        setemail("")
                        setfullname("")
                        // alert("Password Reset Successful")
                        enqueueSnackbar("Password Reset Successful", { variant: 'info' });
                        setpagestate("signin")
                      }).catch((error) => {
                        enqueueSnackbar(error.message, { variant: 'error' });
                        // alert(error.message)
                        console.log(error)
                      })
                    }}>
                      Confirm
                    </SuiButton>
                  </SuiBox>
                  <SuiBox mt={3} textAlign="center">

                    <SuiTypography variant="button" color="text" fontWeight="regular">
                      Have an account?{" "}

                      <SuiTypography
                        variant="button"
                        color="info"
                        fontWeight="medium"
                        onClick={() => { setpagestate("signin") }}
                      >
                        Sign In
                      </SuiTypography>
                    </SuiTypography>
                  </SuiBox>
                </SuiBox>
              </div>
            </div>
          )}
        </div>
        <div style={{ position: "absolute", bottom: "0", width: "100%", textAlign: "center" }}>
          <SuiBox pb={0.3}>
            <SuiTypography variant="caption" color="secondary">
         Private & Confidential. © Digital Internet Association Malaysia. All Rights Reserved. {new Date().getFullYear()}
            </SuiTypography>
          </SuiBox>
        </div>
      </div>
    );
  } else if (pagestate == "signup" && formstate == "ind") {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div style={{ height: "100%", width: "center", display: 'flex', flexDirection: "row", alignItems: "center", justifyItems: "center" }}>

          <div style={{
            width: "50%",
            display: "flex",
            justifyContent: "center",  // Centers horizontally
            alignItems: "center",  // Centers vertically

          }}>
            <img src={iam} style={{ width: "50%" }} alt="Sijil Logo" />
          </div>
          <div style={{ width: "40%", display: 'flex', flexDirection: "row", alignItems: "center" }}>

            <div style={{ width: "98%" }}>
              <SuiBox mb={1}>
                <h3>Create SIJIL account</h3>
              </SuiBox>
              <SuiBox mb={1.5}>
                <div style={{ display: 'flex', flexDirection: "row" }}>
                  <div style={{ width: "50%", display: "flex" }}>
                    <input style={{ marginRight: "5%" }} id="in" type="radio" name="account" value="individual" onChange={() => { setindterms(false); setformstate("ind"); }} />
                    <SuiTypography variant="body2" for="in">Individual</SuiTypography>
                  </div>
                  <div style={{ width: "50%", display: "flex" }}>
                    <input style={{ marginRight: "5%" }} id="or" type="radio" name="account" value="organisation" onChange={() => { setorgterms(false); setformstate("org") }} />
                    <SuiTypography variant="body2" for="or">Organisation</SuiTypography>
                  </div>
                </div>
              </SuiBox>

              <SuiBox component="form" role="form">
                <SuiBox mb={1}>
                  <SuiBox ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Full Name
                    </SuiTypography>
                  </SuiBox>
                  <SuiInput type="text" placeholder="Full Name" onChange={(e) => setfullname(e.target.value)} />
                </SuiBox>

                <SuiBox mb={1}>
                  <SuiBox ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Username (IC/Passport No. without '-' )
                    </SuiTypography>
                  </SuiBox>
                  <SuiInput type="text" placeholder="Username" onChange={(e) => setusername(e.target.value)} />
                </SuiBox>

                <SuiBox mb={1}>
                  <SuiBox ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Email
                    </SuiTypography>
                  </SuiBox>
                  <SuiInput type="text" placeholder="Email" onChange={(e) => setemail(e.target.value)} />
                </SuiBox>

                <SuiBox mb={1}>
                  <SuiBox ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Password
                    </SuiTypography>
                  </SuiBox>
                  <SuiInput type="password" placeholder="Password" onChange={(e) => setpass(e.target.value)} />
                </SuiBox>

                <SuiBox mb={3}>
                  <SuiBox ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Phone Number
                    </SuiTypography>
                  </SuiBox>
                  <PhoneInput
                    className="phoneInputField"
                    international
                    defaultCountry="MY"
                    onChange={(e) => { setphonenum(e) }}
                  />
                </SuiBox>

                <SuiBox mb={1}>
                  <SuiBox ml={0.5}>

                    <LoadCanvasTemplateNoReload />
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", width: "100%" }}>
                      <div style={{ width: "50%" }}>
                        <SuiInput
                          type="text"
                          value={inputValue}
                          onChange={handleInputChange}
                          placeholder="Enter captcha"
                        />
                      </div>
                      <div style={{ marginLeft: "2%", width: "50%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <SuiButton variant="outlined" color="secondary" onClick={(e) => {
                          e.preventDefault()
                          if (validateCaptcha(inputValue)) {
                            setcap(<>
                              <Icon>check_circle</Icon>
                              <SuiTypography style={{ marginLeft: "3%" }} variant="caption">Success</SuiTypography>
                            </>);
                            setcapstatus(true)

                          } else {
                            setcap(
                              <>

                                <Icon>cancel</Icon>
                                <SuiTypography style={{ marginLeft: "3%" }} variant="caption">Please try again</SuiTypography>

                              </>
                            )
                            setcapstatus(false)

                          }
                        }}>Verify</SuiButton>

                        <div style={{ marginLeft: "5%", marginTop: "1%", display: "flex", flexDirection: "row", alignItems: "center", width: "80%" }}>
                          {cap}
                        </div>



                      </div>
                    </div>
                  </SuiBox>
                </SuiBox>

                <SuiBox mt={3}>
                  <div style={{ width: "100%", display: "flex" }}>
                    <input type="checkbox" style={{ marginRight: "4%" }}
                      onChange={(e) => {
                        setindterms(e.target.checked);
                      }} />
                    <p style={{ fontSize: "12px" }}>I have read and agreed to the <a href="http://www.sijil.online/" target="blank"><b>Terms and Conditions</b></a></p>
                  </div>
                </SuiBox>

                <SuiBox mt={2} mb={1}>
                  <SuiButton variant="contained" disabled={!indterms} color="warning" fullWidth onClick={() => {
                    if (capstatus == true) {
                      Auth.signUp({
                        username,
                        password: pass,
                        attributes: {
                          email: email,
                          phone_number: phonenum,
                          "custom:fullname": fullname,
                          "custom:accStatus": "user"
                        }
                      }).then((res) => {
                        setpass("")
                        setusername("")
                        setphonenum("")
                        setemail("")
                        setfullname("")
                        // alert("Sign Up success")
                        enqueueSnackbar("Sign Up success", { variant: 'success' });
                        setpagestate("signin")

                      }).catch((error) => {
                        enqueueSnackbar(error.message, { variant: 'error' });
                        // alert(error.message)
                      })
                    } else {
                      enqueueSnackbar("Verify the captcha to proceed", { variant: 'warning' });
                      // alert("Verify the captcha to proceed")
                    }
                  }}>
                    Sign Up
                  </SuiButton>
                </SuiBox>
                <SuiBox mt={1} textAlign="center">
                  <SuiTypography variant="button" color="text" fontWeight="regular">
                    Have an account?{" "}
                    <SuiTypography
                      variant="button"
                      color="info"
                      fontWeight="medium"
                      onClick={() => {setformstate(""); setpagestate("signin") }}
                      sx={{ cursor: "pointer" }}
                    >
                      Sign In
                    </SuiTypography>
                  </SuiTypography>
                </SuiBox>
              </SuiBox>
            </div>
          </div>
        </div>
        <div style={{ position: "absolute", bottom: "0", width: "100%", textAlign: "center" }}>
          <SuiBox pb={0.3}>
            <SuiTypography variant="caption" color="secondary">
            Private & Confidential. © Digital Internet Association Malaysia. All Rights Reserved. {new Date().getFullYear()}
            </SuiTypography>
          </SuiBox>
        </div>

      </div>
    );
  } else if (pagestate == "signup" && formstate == "org") {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div style={{ height: "100%", width: "center", display: 'flex', flexDirection: "row", alignItems: "center", justifyItems: "center" }}>

          <div style={{
            width: "50%",
            display: "flex",
            justifyContent: "center",  // Centers horizontally
            alignItems: "center",  // Centers vertically

          }}>
            <img src={iam} style={{ width: "50%" }} alt="Sijil Logo" />
          </div>

          <div style={{ width: "40%", display: 'flex', flexDirection: "row", alignItems: "center" }}>

            <div style={{ width: "98%" }}>
              <SuiBox mb={1}>
                <h3>Create SIJIL account</h3>
              </SuiBox>
              <SuiBox mb={2}>
                <div style={{ display: 'flex', flexDirection: "row" }}>
                  <div style={{ width: "50%", display: "flex" }}>
                    <input style={{ marginRight: "5%" }} id="in" type="radio" name="account" value="individual" onChange={() => { setindterms(false); setformstate("ind"); }} />
                    <SuiTypography variant="body2" for="in">Individual</SuiTypography>
                  </div>

                  <div style={{ width: "50%", display: "flex" }}>
                    <input style={{ marginRight: "5%" }} id="or" type="radio" name="account" value="organisation" onChange={() => { setorgterms(false); setformstate("org") }} />
                    <SuiTypography variant="body2" for="or">Organisation</SuiTypography>
                  </div>
                </div>
              </SuiBox>

              <SuiBox component="form" role="form">

                <Grid container spacing={1}>
                  <Grid item lg={6}>
                    <SuiBox mb={1}>
                      <SuiBox ml={0.5}>
                        <SuiTypography component="label" variant="caption" fontWeight="bold">
                          Company Name
                        </SuiTypography>
                      </SuiBox>
                      <SuiInput type="text" placeholder="Company Name" onChange={(e) => setcompanyname(e.target.value)} />
                    </SuiBox>
                  </Grid>


                  <Grid item lg={6}>
                    <SuiBox mb={1}>
                      <SuiBox ml={0.5}>
                        <SuiTypography component="label" variant="caption" fontWeight="bold">
                          Company SSM
                        </SuiTypography>
                      </SuiBox>
                      <SuiInput type="text" placeholder="Company SSM" onChange={(e) => setssm(e.target.value)} />
                    </SuiBox>
                  </Grid>


                  <Grid item lg={6}>
                  <SuiBox mb={1}>
                      <SuiBox ml={0.5}>
                        <SuiTypography component="label" variant="caption" fontWeight="bold">
                          Admin Full Name
                        </SuiTypography>
                      </SuiBox>
                      <SuiInput type="text" placeholder="Full Name" onChange={(e) => setfullname(e.target.value)} />
                    </SuiBox>
                  </Grid>

                  <Grid item lg={6}>
                  <SuiBox mb={1}>
                  <SuiBox ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Admin Username (IC/Passport No. without '-' )
                    </SuiTypography>
                  </SuiBox>
                  <SuiInput type="text" placeholder="Username" onChange={(e) => setusername(e.target.value)} />
                </SuiBox>
                    </Grid>

                </Grid>

                <SuiBox mb={1}>
                  <SuiBox ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Email
                    </SuiTypography>
                  </SuiBox>
                  <SuiInput type="text" placeholder="Email" onChange={(e) => setemail(e.target.value)} />
                </SuiBox>

                <SuiBox mb={1}>
                  <SuiBox ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Password
                    </SuiTypography>
                  </SuiBox>
                  <SuiInput type="password" placeholder="Password" onChange={(e) => setpass(e.target.value)} />
                </SuiBox>

                <SuiBox mb={3}>
                  <SuiBox ml={0.5}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Phone Number
                    </SuiTypography>
                  </SuiBox>
                  <PhoneInput
                    className="phoneInputField"
                    international
                    defaultCountry="MY"
                    onChange={(e) => { setphonenum(e) }}
                  />
                </SuiBox>

                <SuiBox mb={1}>
                  <SuiBox ml={0.5}>

                    <LoadCanvasTemplateNoReload />
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", width: "100%" }}>
                      <div style={{ width: "50%" }}>
                        <SuiInput
                          type="text"
                          value={inputValue}
                          onChange={handleInputChange}
                          placeholder="Enter captcha"
                        />
                      </div>
                      <div style={{ marginLeft: "2%", width: "50%", display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <SuiButton variant="outlined" color="secondary" onClick={(e) => {
                          e.preventDefault()
                          if (validateCaptcha(inputValue)) {
                            setcap(<>
                              <Icon>check_circle</Icon>
                              <SuiTypography style={{ marginLeft: "3%" }} variant="caption">Success</SuiTypography>
                            </>);
                            setcapstatus(true)

                          } else {
                            setcap(
                              <>

                                <Icon>cancel</Icon>
                                <SuiTypography style={{ marginLeft: "3%" }} variant="caption">Please try again</SuiTypography>

                              </>
                            )
                            setcapstatus(false)

                          }
                        }}>Verify</SuiButton>

                        <div style={{ marginLeft: "5%", marginTop: "1%", display: "flex", flexDirection: "row", alignItems: "center", width: "80%" }}>
                          {cap}
                        </div>



                      </div>
                    </div>
                  </SuiBox>
                </SuiBox>

                <SuiBox mt={3}>
                  <div style={{ width: "100%", display: "flex" }}>
                    <input type="checkbox" style={{ marginRight: "4%" }}
                      onChange={(e) => {


                        setorgterms(e.target.checked);

                      }} />
                    <p style={{ fontSize: "12px" }}>I have read and agreed to the <a href="http://www.sijil.online/" target="blank"><b>Terms and Conditions</b></a></p>
                  </div>
                </SuiBox>

                <SuiBox mt={2} mb={1}>
                  <SuiButton variant="contained" color="warning" disabled={!orgterms} fullWidth
                    onClick={() => {

                      var domain = "";
                      domain = email.substring(email.indexOf("@") + 1, email.length);
                      const freeEmailDomains = require("free-email-domains")

                      if (capstatus == true) {
                        Auth.signUp({
                          username,
                          password:pass,
                          attributes: {
                            email: email,
                            phone_number: phonenum,
                            "custom:ssm": ssm,
                            "custom:company": companyname,
                            "custom:fullname": fullname,
                            "custom:accStatus": "organizer",
                            "custom:approvalStatus": "1"
                          }
                        }).then((res) => {
                          setpass("")
                          setusername("")
                          setphonenum("")
                          setemail("")
                          setfullname("")
                          // alert("Sign Up success")
                          enqueueSnackbar("Sign Up success", { variant: 'success' });
                          setcompanyname("")
                          setpagestate("signin")


                        }).catch((error) => {
                          enqueueSnackbar(error.message, { variant: 'error' });
                          // alert(error.message)
                        })
                      } else {
                        enqueueSnackbar("Verify the captcha to proceed", { variant: 'warning' });
                      }

                    }}
                  >
                    Sign Up
                  </SuiButton>
                </SuiBox>
                <SuiBox mt={1} textAlign="center">
                  <SuiTypography variant="button" color="text" fontWeight="regular">
                    Have an account?{" "}
                    <SuiTypography
                      variant="button"
                      color="info"
                      fontWeight="medium"
                      onClick={() => { setformstate(""); setpagestate("signin") }}
                    >
                      Sign In
                    </SuiTypography>
                  </SuiTypography>
                </SuiBox>
              </SuiBox>
            </div>
          </div>
        </div>

        <div style={{ position: "absolute", bottom: "0", width: "100%", textAlign: "center" }}>
          <SuiBox pb={0.3}>
            <SuiTypography variant="caption" color="secondary">
             Private & Confidential. © Digital Internet Association Malaysia. All Rights Reserved. {new Date().getFullYear()}
            </SuiTypography>
          </SuiBox>
        </div>

      </div>
    )
  }
  else if (pagestate == "signup" && formstate == "") {

    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div style={{ height: "100%", width: "center", display: 'flex', flexDirection: "row", alignItems: "center", justifyItems: "center" }}>

          <div style={{
            width: "50%",
            display: "flex",
            justifyContent: "center",  // Centers horizontally
            alignItems: "center",  // Centers vertically

          }}>
            <img src={iam} style={{ width: "50%" }} alt="Sijil Logo" />
          </div>

          <div style={{ width: "40%", display: 'flex', flexDirection: "row", alignItems: "center" }}>

            <div style={{ width: "90%" }}>
              <SuiBox mb={1}>
                <h3>Create SIJIL account</h3>
              </SuiBox>
              <SuiBox mb={3}>
                <div style={{ display: 'flex', flexDirection: "row" }}>
                  <div style={{ width: "50%", display: "flex" }}>
                    <input style={{ marginRight: "5%" }} id="in" type="radio" name="account" value="individual" onChange={() => { setindterms(false); setformstate("ind"); }} />
                    <SuiTypography variant="body2" for="in">Individual</SuiTypography>
                  </div>

                  <div style={{ width: "50%", display: "flex" }}>
                    <input style={{ marginRight: "5%" }} id="or" type="radio" name="account" value="organisation" onChange={() => { setorgterms(false); setformstate("org") }} />
                    <SuiTypography variant="body2" for="or">Organisation</SuiTypography>
                  </div>
                </div>
              </SuiBox>
            </div>
          </div>
        </div>

        <div style={{ position: "absolute", bottom: "0", width: "100%", textAlign: "center" }}>
          <SuiBox pb={0.3}>
            <SuiTypography variant="caption" color="secondary">
Private & Confidential. © Digital Internet Association Malaysia. All Rights Reserved. {new Date().getFullYear()}
            </SuiTypography>
          </SuiBox>
        </div>
      </div>
    )
  }
}

export default SignIn;

